import {
  AlertDialog,
  AlertDialogBody,
  AlertDialogContent,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogOverlay,
  AlertDialogProps,
  Button,
  Divider,
  HStack,
} from '@chakra-ui/react';
import { useTranslations } from 'use-intl';

import { noop } from '@blockpulse3/data/shared';

type Props = {
  onConfirm?: () => void;
  onClose: () => void;
  leastDestructiveRef: AlertDialogProps['leastDestructiveRef'];
} & Omit<AlertDialogProps, 'onClose' | 'children' | 'leastDestructiveRef'>;

/**
 * FiscalAccountDeleteModal.
 * Confirmation box on Fiscal Account deletion.
 *
 * @param {Props}
 * @returns {JSX.Element}
 */
export function FiscalAccountDeleteModal({
  onConfirm = noop,
  onClose,
  ...props
}: Props): JSX.Element {
  const i18nGeneral = useTranslations('General');
  const i18nDeleteFiscalAccountModal = useTranslations('FiscalAccountDeleteModal');

  return (
    <AlertDialog onClose={onClose} {...props}>
      <AlertDialogOverlay>
        <AlertDialogContent>
          <AlertDialogHeader fontSize="xl" fontWeight="500">
            {i18nDeleteFiscalAccountModal('Title')}
          </AlertDialogHeader>
          <AlertDialogBody>{i18nDeleteFiscalAccountModal('SubTitle')}</AlertDialogBody>
          <Divider />
          <AlertDialogFooter as={HStack} spacing="4">
            <Button variant="secondary" onClick={onClose}>
              {i18nGeneral('Cancel')}
            </Button>
            <Button variant="delete" onClick={onConfirm}>
              {i18nGeneral('Delete')}
            </Button>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialogOverlay>
    </AlertDialog>
  );
}
